import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ContentElement } from '../../../models/sections-model';

@Component({
  selector: 'kw-form-field-renderer',
  templateUrl: './form-field-renderer.component.html',
  styleUrls: ['./form-field-renderer.component.scss']
})
export class FormFieldRendererComponent implements OnInit, OnChanges {
  contentElement:ContentElement;
  headerHasFocus:boolean;
  headerHasChanged:boolean;
  headerText = "";

  constructor() { }
  ngOnChanges(changes: SimpleChanges): void {
    if(changes["contentElement"]){
      console.log(this.contentElement);
    }
  }

  ngOnInit(): void {
  }

  onHeaderFocus(e){

  } 
  onKeyDownEvent(e){
   this.headerHasFocus = true; 
  }
  onKeyHeader(e){

  }

  onClearHeader(){}

  onSubmitHeader(){}

}
